import {
    initialOpenSubmissionsConfiguration,
    OpenSubmissionsConfiguration,
} from './OpenSubmissionsConfiguration';
import { WidgetType } from 'widgets/WidgetType';
import { WidgetActionType } from 'widgets/store/actions';
import { OpenSubmissionsColumn } from '../../grid/OpenSubmissionsColumn';
import {
    buildConfigReducerWithGridSupport,
    ConfigStateWithGridSupportGenericAction,
    ConfigStateWithGridSupportSupportedActions,
} from 'widgets/store/grid/reducer';

export const openSubmissionsConfigReducer = buildConfigReducerWithGridSupport(
    WidgetType.OPEN_SUBMISSIONS,
    initialOpenSubmissionsConfiguration,
    { preProcessor }
);

function preProcessor(
    action: ConfigStateWithGridSupportSupportedActions<
        OpenSubmissionsColumn,
        OpenSubmissionsConfiguration
    >
) {
    if (action.type === WidgetActionType.WIDGET_LOAD_CONFIG) {
        upgradeLegacyConfig(action);
    }
}

function upgradeLegacyConfig(
    action: ConfigStateWithGridSupportGenericAction<
        OpenSubmissionsColumn,
        OpenSubmissionsConfiguration
    >
) {
    action.payload!.configDelta = action.payload!.configDelta || {};
    const configDelta = action.payload!.configDelta;

    if (configDelta.sort) {
        configDelta.sort = configDelta.sort.map((s) => ({
            colId: upgradeLegacySortCol(s.colId),
            sort: s.sort,
        }));
    }
    if (configDelta.hideToolbar === undefined) {
        configDelta.hideToolbar = true;
    }
}

function upgradeLegacySortCol(
    colId: OpenSubmissionsColumn | 'started'
): OpenSubmissionsColumn {
    return colId === 'started' ? 'updateTimeEpoch' : colId;
}
